import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DateTimeWithSpaceConvertorPipe } from './date-time-with-space-convertor.pipe';
import { ParseJsonPipe } from './pase-json.pipe';
import { DateConverterPipe } from 'src/app/core/pipes/date-converter.pipe';
import { DateTimeConvertorPipe } from './date-time-convertor.pipe';
import { AddApiUrlBeforePathPipe } from './add-api-url-before-path.pipe';
import { NumberSeparatorPipe } from './number.separator.pipe';
import { CurrencyPipe } from './currency.pipe';
import { CheckValuePipe } from './value.pipe';
import { FullDateConverterPipe } from './full-date-converter.pipe';
import { DateTimeWithSecondConvertorPipe } from './date-time-with-second-convertor.pipe';
import { IpDisplayerPipe } from './ip-displayer.pipe';
import { TimerPipe } from './timer.pipe';
import { EnumToTextConvertorPipe } from './enum-text.pipe';
import { MinutesLaterPipe } from './minutes-later.pipe';
import { FileTypePipe } from './file-type.pipe';
import { EnumValuePipe } from './enum-value.pipe';
import { joinPipe } from './join.pipe';
import { LogDataPipe } from './log-data.pipe';
import { ValueLessThanZeroPipe } from './value-less-than-zero.pipe';
import { ConvertToStringPipe } from './convert-to-string.pipe';
import { ConvertDateToTimePipe } from './convert-date-to-time.pipe';
import { TimeConverterPipe } from './time-converter.pipe';
import { OrderByPipe } from './order-by.pipe';
//
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    ParseJsonPipe,
    DateConverterPipe,
    DateTimeConvertorPipe,
    CurrencyPipe,
    NumberSeparatorPipe,
    CheckValuePipe,
    FullDateConverterPipe,
    DateTimeWithSecondConvertorPipe,
    IpDisplayerPipe,
    TimerPipe,
    EnumToTextConvertorPipe,
    MinutesLaterPipe,
    FileTypePipe,
    EnumToTextConvertorPipe,
    DateTimeWithSpaceConvertorPipe,
    EnumValuePipe,
    AddApiUrlBeforePathPipe,
    joinPipe,
    LogDataPipe,
    ValueLessThanZeroPipe,
    ConvertToStringPipe,
    ConvertDateToTimePipe,
    TimeConverterPipe,
    OrderByPipe,
  ],
  exports: [
    ParseJsonPipe,
    DateConverterPipe,
    DateTimeConvertorPipe,
    CurrencyPipe,
    NumberSeparatorPipe,
    CheckValuePipe,
    FullDateConverterPipe,
    DateTimeWithSecondConvertorPipe,
    IpDisplayerPipe,
    TimerPipe,
    EnumToTextConvertorPipe,
    MinutesLaterPipe,
    FileTypePipe,
    EnumToTextConvertorPipe,
    DateTimeWithSpaceConvertorPipe,
    EnumValuePipe,
    AddApiUrlBeforePathPipe,
    joinPipe,
    LogDataPipe,
    ValueLessThanZeroPipe,
    ConvertToStringPipe,
    ConvertDateToTimePipe,
    TimeConverterPipe,
    OrderByPipe,
  ],
  providers: [FileTypePipe, EnumToTextConvertorPipe],
})
export class SharePipesModule { }
